// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"11ac7cf4","238":"6fb866d4","252":"6e7ecbd5","435":"49a38d8a","539":"fe12446c","697":"a9eaf7a4"}[chunkId] + ".chunk.js";
};